import styles from './UserAccountMenu.less';

import React, { Component } from 'react';

import { signInRegUrlPrefix } from 'config';
import {
  ProfileIcon,
  HeartIcon,
  StarIcon
} from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';

const clearLocalStorage = () => localStorage.clear();

export default class UserAccountMenu extends Component {

  render() {
    return (
      <ul className={styles.root}>
        <li>
          <ExternalLink
            className={styles.item}
            href="/profile/">
            Your profile<ProfileIcon className={styles.icon} svgClassName={styles.iconSvg} />
          </ExternalLink>
        </li>
        <li>
          <ExternalLink
            className={`${styles.item} ${styles.subItem}`}
            href="/myactivity#favourite">
            Saved searches<HeartIcon className={styles.icon} svgClassName={styles.iconSvg} />
          </ExternalLink>
        </li>
        <li>
          <ExternalLink
            className={`${styles.item} ${styles.subItem}`}
            href="/my-activity/saved-jobs">
            Saved jobs<StarIcon className={styles.icon} svgClassName={styles.iconSvg} />
          </ExternalLink>
        </li>
        <li>
          <ExternalLink
            className={`${styles.item} ${styles.subItem}`}
            href="/my-activity/applied-jobs">
            Applied jobs
          </ExternalLink>
        </li>
        <li>
          <ExternalLink
            className={styles.item}
            href="/settings/">
            Settings
          </ExternalLink>
        </li>
        <li>
          <ExternalLink
            className={styles.item}
            intercept={clearLocalStorage}
            href={`${signInRegUrlPrefix}/Login/Logout`}>
            Sign out
          </ExternalLink>
        </li>
      </ul>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Header/components/UserAccount/components/UserAccountMenu/UserAccountMenu.js
 **/